// eslint-disable-next-line import/no-mutable-exports
let join = (delim, ...args) => {
  let exp = new RegExp(['^\\', delim, '*|\\', delim, '*$'].join(''))
  return args.map(x => String(x || '').trim().replace(exp, '')).filter(x => x).join(delim)
}

// eslint-disable-next-line import/no-mutable-exports
let url = (...args) => {
  args.unshift('/')
  return join.apply(null, args)
}

export default {
  join: join,
  url: url
}

export { url as url, join as join }